(function () {
    'use strict';

    var API_BASE = 'https://pollingreport.uk/api/v1';
    var PARTY_KEYS = ['con', 'lab', 'lib', 'snp', 'green', 'reform', 'plaid', 'other'];
    var PARTY_META = {
        con: { short: 'CON' },
        lab: { short: 'LAB' },
        lib: { short: 'LIB' },
        snp: { short: 'SNP' },
        green: { short: 'GRN' },
        reform: { short: 'REF' },
        plaid: { short: 'PC' },
        other: { short: 'OTH' }
    };
    var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    var roots = document.querySelectorAll('[data-ukpr-polls-table]');
    if (!roots.length) return;

    roots.forEach(function (root) {
        if (root.dataset.initialized === 'true') return;
        root.dataset.initialized = 'true';
        initWidget(root);
    });

    function initWidget(root) {
        var bodyEl = root.querySelector('[data-polls-table-body]');
        var metaEl = root.querySelector('[data-polls-table-meta]');
        var pageStatusEl = root.querySelector('[data-polls-page-status]');
        var prevBtn = root.querySelector('[data-polls-page-prev]');
        var nextBtn = root.querySelector('[data-polls-page-next]');
        var areaBtns = root.querySelectorAll('[data-polls-area]');
        var state = { page: 1, perPage: 10, area: 'GB', meta: null, loading: false, hasLoaded: false };

        function escHtml(str) {
            return String(str || '')
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/\"/g, '&quot;')
                .replace(/'/g, '&#39;');
        }

        function formatShortDate(str) {
            if (!str) return '';
            var parts = String(str).split('-');
            if (parts.length < 3) return str;
            return parseInt(parts[2], 10) + ' ' + MONTHS[parseInt(parts[1], 10) - 1];
        }

        function formatDateRange(from, to) {
            if (!from && !to) return '-';
            if (!to || from === to) return formatShortDate(from || to);
            return formatShortDate(from) + ' - ' + formatShortDate(to);
        }

        function formatNumber(value) {
            if (value == null || value === '') return '-';
            return new Intl.NumberFormat('en-GB').format(Number(value));
        }

        function formatPct(value) {
            if (value == null || value === '') return '—';
            return String(value);
        }

        function renderPollster(poll) {
            var pollsterName = escHtml((poll.pollster && poll.pollster.name) || 'Unknown');
            var clientName = escHtml((poll.client && poll.client.name) || '');
            var url = poll.url ? ' href="' + escHtml(poll.url) + '" target="_blank" rel="noopener noreferrer"' : '';
            var main = url
                ? '<a class="ukpr-polls-table-link"' + url + '>' + pollsterName + '</a>'
                : '<span class="ukpr-polls-table-link is-static">' + pollsterName + '</span>';
            var sub = clientName ? '<span class="ukpr-polls-table-sub">' + clientName + '</span>' : '';
            return main + sub;
        }

        function renderLead(poll) {
            var winner = String(poll.winner || 'other').toLowerCase();
            var party = PARTY_META[winner] || PARTY_META.other;
            var leadValue = Number(poll.lead || 0);
            return '<span class="ukpr-polls-table-chip winner-' + escHtml(winner) + '" title="Lead: ' + escHtml(party.short) + '">' + leadValue + '</span>';
        }

        function renderRows(items) {
            if (!items.length) {
                bodyEl.innerHTML = '<tr><td class="ukpr-polls-table-empty" colspan="12">No polls available.</td></tr>';
                return;
            }

            bodyEl.innerHTML = items.map(function (poll) {
                var cells = PARTY_KEYS.map(function (key) {
                    return '<td class="ukpr-polls-table-party cell-' + escHtml(key) + '"><span>' + escHtml(formatPct(poll[key])) + '</span></td>';
                }).join('');

                return [
                    '<tr>',
                    '<td class="ukpr-polls-table-fieldwork">' + escHtml(formatDateRange(poll.from, poll.to)) + '</td>',
                    '<td class="ukpr-polls-table-pollster">' + renderPollster(poll) + '</td>',
                    '<td class="ukpr-polls-table-sample is-numeric">' + escHtml(formatNumber(poll.sample_size)) + '</td>',
                    cells,
                    '<td class="ukpr-polls-table-lead is-numeric">' + renderLead(poll) + '</td>',
                    '</tr>'
                ].join('');
            }).join('');
        }

        function updatePagination() {
            var meta = state.meta || {};
            var current = Number(meta.current_page || state.page || 1);
            var last = Number(meta.last_page || 1);
            var total = Number(meta.total || 0);
            if (metaEl) {
                metaEl.textContent = total ? total + ' polls' : '';
            }
            pageStatusEl.textContent = 'Page ' + current + ' of ' + last;
            prevBtn.disabled = state.loading || current <= 1;
            nextBtn.disabled = state.loading || current >= last;
        }

        function updateAreaButtons() {
            areaBtns.forEach(function (btn) {
                btn.classList.toggle('is-active', btn.dataset.pollsArea === state.area);
                btn.disabled = state.loading;
            });
        }

        function setLoading() {
            if (!state.hasLoaded) {
                bodyEl.innerHTML = '<tr><td class="ukpr-polls-table-empty" colspan="12">Loading latest polls...</td></tr>';
            }
            root.classList.add('is-loading');
            updatePagination();
        }

        function setError() {
            root.classList.remove('is-loading');
            if (!state.hasLoaded) {
                bodyEl.innerHTML = '<tr><td class="ukpr-polls-table-empty" colspan="12">Poll data unavailable.</td></tr>';
            }
            updatePagination();
        }

        function clearLoadingState() {
            root.classList.remove('is-loading');
        }

        function fetchPage() {
            state.loading = true;
            setLoading();
            updateAreaButtons();

            var url = API_BASE + '/polls?paginate=true&per_page=' + encodeURIComponent(state.perPage)
                + '&page=' + encodeURIComponent(state.page)
                + '&area=' + encodeURIComponent(state.area);
            var xhr = new XMLHttpRequest();
            xhr.open('GET', url);
            xhr.onload = function () {
                state.loading = false;
                if (xhr.status !== 200) {
                    setError();
                    return;
                }
                try {
                    var payload = JSON.parse(xhr.responseText);
                    state.meta = payload.meta || null;
                    renderRows(Array.isArray(payload.data) ? payload.data : []);
                    state.hasLoaded = true;
                    requestAnimationFrame(clearLoadingState);
                    updatePagination();
                    updateAreaButtons();
                } catch (e) {
                    setError();
                }
            };
            xhr.onerror = function () {
                state.loading = false;
                setError();
            };
            xhr.send();
        }

        prevBtn.addEventListener('click', function () {
            if (state.loading || state.page <= 1) return;
            state.page -= 1;
            fetchPage();
        });

        nextBtn.addEventListener('click', function () {
            var last = Number((state.meta && state.meta.last_page) || 1);
            if (state.loading || state.page >= last) return;
            state.page += 1;
            fetchPage();
        });

        areaBtns.forEach(function (btn) {
            btn.addEventListener('click', function () {
                var nextArea = btn.dataset.pollsArea;
                if (state.loading || !nextArea || nextArea === state.area) return;
                state.area = nextArea;
                state.page = 1;
                fetchPage();
            });
        });

        updateAreaButtons();
        updatePagination();
        fetchPage();
    }
})();
